import type { Periodicity } from "./api";

/** The visit schedules in the order every picker shows them; `key` names `contacts.schedule_<key>`. */
export const SCHEDULE_OPTIONS: { value: Periodicity; key: string }[] = [
  { value: "Bi-Monthly", key: "twice_a_month" }, { value: "Monthly", key: "monthly" }, { value: "Quarterly", key: "quarterly" },
  { value: "Bi-Annually", key: "twice_a_year" }, { value: "Annually", key: "yearly" }, { value: "None", key: "none" },
];

export const PERIODICITIES: Periodicity[] = SCHEDULE_OPTIONS.map((o) => o.value);

export const SCHEDULE_KEY = Object.fromEntries(SCHEDULE_OPTIONS.map((o) => [o.value, o.key])) as Record<Periodicity, string>;
